import React from 'react';
import { Link, useLocation,useNavigate } from "react-router-dom";
import Axios from "axios";
import { useState, useEffect } from 'react';
import { useForm,Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import 'react-toastify/dist/ReactToastify.css';
import { GetUserDetailsByGuid, UpdateUsersInfo } from '../apiconstants/constants';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Swal from 'sweetalert2';
import ConsultantLayout from '../commonlayouts/consultantlayout';
import LoadingSpinner from '../helpers/loadingspinner';
import Select from 'react-select';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function EditUser() {
  let query = useQuery();
  var Guid= query.get("guid");
  const navigate = useNavigate();

  const formSchema = Yup.object().shape({
    terms: Yup.bool() // use bool instead of boolean
      .oneOf([true], "You must accept the terms and conditions"),
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    mobile: Yup.string().required('Mobile Number is required'),
       CountryMappings: Yup.array()
          .min(1, "At least one country must be selected")
          .required("At least one country must be selected"),
  })
  const clientData = JSON.parse(localStorage.getItem("clientData"));
  const formOptions = { resolver: yupResolver(formSchema) }
  const { register, handleSubmit, setValue, formState,control } = useForm(formOptions);
  const { errors } = formState
  const { isSubmitting } = formState;
  const [isLoading, setIsLoading] = useState(false);
  const [loginType,setloginType] = useState([
    {LoginID:"3",loginName:"User"},
    // {LoginID:"4",loginName:"Cem"},
    ]) 
   const token = localStorage.getItem("jwtToken");
  useEffect(() => {
    GetDetails();
  }, []);
  const countryOptions = [
    { value: "1", label: "India" },
    { value: "2", label: "United States" }
  ];
  const GetDetails = () => {
  const GetapiUrl = `${GetUserDetailsByGuid.APIURL}/${Guid}`;

  Axios.get(GetapiUrl, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((result) => {
      const user = result.data[0];

      setValue("firstName", user.firstName);
      setValue("lastName", user.lastName);
      setValue("mobile", user.mobileNumber);
      setValue("companyName", user.companyName);
      setValue("email", user.email);
      setValue("companyURL", user.companyURL);
      setValue("roleID", "User");

      // ✅ FIX: convert comma string → array for multi-select
      const usertypeArray = user.usertype
        ? user.usertype.split(",").map((s) => s.trim())
        : [];

      setValue("Usertype", usertypeArray);

      // ✅ FIX: process country mappings
      const selectedCountries = user.countryID
        ?.split(",")
        .map((id) =>
          countryOptions.find((opt) => opt.value === id.trim())
        )
        .filter(Boolean);

      setValue("CountryMappings", selectedCountries);
    })
    .catch((err) => {
      console.error("Error fetching user details:", err);
    });
};


    const onSubmit = (data) => {
      console.log("data", data);
      setIsLoading(true);
    
      const formData = new FormData();
      formData.append('firstName', data.firstName);
      formData.append('lastName', data.lastName);
      formData.append('CompanyName', clientData?.companyName);
      formData.append('email', data.email);
      formData.append('mobileNumber', data.mobile);
      formData.append('LogoURL', clientData?.logoURL);
      formData.append('Guid', Guid);
        formData.append('Usertype', data.Usertype);
      formData.append('CountryMappings', data.CountryMappings.map(c => c.value));

      Axios.put(UpdateUsersInfo.APIURL, formData, {
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "multipart/form-data"
    }
  })
        .then((result) => {
          setIsLoading(false);
          if (result.data.message === " Record upadted successfully") {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'updated successfully',
              showConfirmButton: false,
              timer: 5000
            });
            navigate('/Employer/ListofUsers');
          } else {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: 'Something went wrong',
              showConfirmButton: false,
              timer: 5000
            });
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    };



  return (
    <ConsultantLayout>
          {isLoading ? (
         <center>
        <LoadingSpinner/>
         </center>
       )  :
       <div className="container-fluid mt-4 pb-5">
       <div style={{ display: 'flex', alignItems: 'center' }}>
     <Link to="/Employer/ListOfUsers">
     <i className="fa  fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px' }} aria-hidden="true"></i>
     </Link>
     <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: '0' }}>Edit User</h2>
     </div>
     <hr/>
     <div className="bg-gray mt-4">
         
     
          <form onSubmit={handleSubmit(onSubmit)} id="loginform">
         <div class="row" >
             
             
             <div class="" style={{height: 900}}>
                    
                     
                     <div class="mb-3 mt-5">
                     <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> First Name</Tooltip>)}>
     
     <input
       placeholder='First Name'
       type="text"
       name="firstName"
       {...register("firstName")}
       className={`form-control shadow-sm ${errors.firstName ? 'is-invalid' : ''}`}
     
     />
     </OverlayTrigger>
     <div className="invalid-feedback"> {errors.firstName?.message}</div> 
                       </div>
                       <div class="mb-3 mt-4">
                       <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Last Name</Tooltip>)}>
                       <input
                         placeholder='Last Name'
                         type="text"
                         name="lastName"
                         {...register("lastName")}
                         className={`form-control shadow-sm ${errors.lastName ? 'is-invalid' : ''}`}
     
                       />
                     </OverlayTrigger>
                     <div className="invalid-feedback"> {errors.lastName?.message}</div>  
                       </div>
                       <div class="mb-3 mt-4">
                       <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Email</Tooltip>)}>
                       <input
                         placeholder='Email'
                         type="email"
                         name="email"
                         disabled
                         {...register("email")}
                         className={`form-control shadow-sm ${errors.email ? 'is-invalid' : ''}`}
     
                       />
                     </OverlayTrigger>
                     <div className="invalid-feedback"> {errors.email?.message}</div>
                         </div>
     
                         <div class="mb-3 mt-4">
                         <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>
                       <input
                         placeholder='Mobile Number'
                         type="text"
                         name="mobile"
                         {...register("mobile")}
                         className={`form-control shadow-sm ${errors.mobile ? 'is-invalid' : ''}`}
     
                       />
                     </OverlayTrigger>
                     <div className="invalid-feedback"> {errors.mobile?.message}</div>
                         </div>

                      <div className="mb-3 mt-4">

  {/* USER TYPE DROPDOWN */}
  <OverlayTrigger
    placement="bottom"
    overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Select User Type</Tooltip>
    )}
  >
    <select
      {...register("roleID", { required: "User Type Required" })}
      disabled
      className={`form-control basic-form mt-3 ${errors.roleID ? "is-invalid" : ""}`}
      style={{ height: 50, borderRadius: 15 }}
    >
      <option value="">Select User Type</option>

      {loginType.map((item, index) => (
        <option key={index} value="User">
          User
        </option>
      ))}

    </select>
  </OverlayTrigger>

  {/* COUNTRY MAPPINGS MULTI-SELECT */}
  <div className="mt-3">
    <Controller
      name="CountryMappings"
      control={control}
      rules={{ required: "At least one country must be selected" }}
      render={({ field }) => (
        <Select
          {...field}
          options={countryOptions}
          isMulti
          placeholder="Select Country Mappings"
          value={field.value || []} // ensure array
          onChange={(selected) => field.onChange(selected)} // save array of objects
          className={`basic-form ${errors.CountryMappings ? "is-invalid" : ""}`}
          styles={{
            control: (provided) => ({
              ...provided,
              minHeight: 50,
              borderRadius: 15,
              borderColor: errors.CountryMappings ? "red" : provided.borderColor,
            }),
            placeholder: (provided) => ({
              ...provided,
              fontSize: "14px",
              color: "#999",
            }),
          }}
        />
      )}
    />

    {errors.CountryMappings && (
      <div className="invalid-feedback d-block">
        {errors.CountryMappings.message}
      </div>
    )}
  </div>

  {/* USERTYPE MULTI-SELECT */}
  <div className="mt-3">
    <Controller
      name="Usertype"
      control={control}
      rules={{ required: "Designation type required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={[
            { value: "Recruiter", label: "Recruiter" },
            { value: "Bench Sales", label: "Bench Sales" },
          ]}
          isMulti
          placeholder="Select Designation Type"

          // 💡 Display multiple selected values
         value={
  Array.isArray(field.value)
    ? field.value.map((val) => ({ value: val, label: val }))
    : []
}


          // 💡 Store array of values in form
          onChange={(selected) => {
            const values = selected ? selected.map((opt) => opt.value) : [];
            field.onChange(values);
          }}

          className={`basic-form ${errors.Usertype ? "is-invalid" : ""}`}
          styles={{
            control: (provided) => ({
              ...provided,
              minHeight: 50,
              borderRadius: 15,
              borderColor: errors.Usertype ? "red" : provided.borderColor,
            }),
            placeholder: (provided) => ({
              ...provided,
              fontSize: "12px",
              color: "#999",
            }),
            menu: (provided) => ({ ...provided, fontSize: "12px" }),
            option: (provided) => ({ ...provided, fontSize: "12px" }),
          }}
        />
      )}
    />

    {errors.Usertype && (
      <div className="invalid-feedback d-block">
        {errors.Usertype.message}
      </div>
    )}
  </div>
</div>

     
     
                        <div className='text-center'>
                       <button disabled={isSubmitting} class="btn btn-primary " style={{backgroundColor:"#00a7ac",border:"none",borderRadius: 15}}>
                       {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                    Submit
                     </button> 
                    <Link to="/Employer/ListofUsers"> <button  class="btn btn-primary " style={{backgroundColor:"#00a7ac",border:"none",borderRadius: 15}}>
         
                      Cancel
                     </button>
                     </Link>
     
                     </div> 
             </div>
             </div>
             </form>
        </div>
       </div>
     }
    </ConsultantLayout>

  )
}

export default EditUser;